module.exports = __webpack_public_path__ + "media/packs/images/trix_horizontal_rule-4a724045627304bbafc3ffd9015f5783.svg";